module.exports = __webpack_public_path__ + "img/jsyh.db8dd308.png";